
import Component, { mixins } from 'vue-class-component';

import { namespace } from 'vuex-class';

import ContractStore from '@/store/modules/contract';

import SessionMixin from '@/mixins/session';

import AsyncProvider from '@/components/AsyncProvider.vue';
import Skeleton from '@/components/Skeleton.vue';
import Hint from '@/components/Hint.vue';
import { IContract } from '@/types/contract';

import CardContract from './components/CardContract.vue';

const contract = namespace('contract');

@Component({
  components: {
    CardContract,
    AsyncProvider,
    Skeleton,
    Hint,
  },
})

export default class InvoicesView extends mixins(SessionMixin) {
  private once = false;

  public returnurl = `${process.env.VUE_APP_PAYMENT_HISTORY_URL}/v3/contract`;

  public loading = true;

  public maestroContextType = (window as any).maestroContextType;

  private cancelHint = {
    title: `${this.$t('INVOICES_RECEIPTS.HINT.PLAN_AND_CONTRACT_CANCELLATION_TITLE')}`,
    subtitle: `${this.$t('INVOICES_RECEIPTS.HINT.PLAN_AND_CONTRACT_CANCELLATION_SUBTITLE')}`,
    link: `${this.$t('INVOICES_RECEIPTS.HINT.PLAN_AND_CONTRACT_CANCELLATION_CENTRAL_HELP_LINK')}`,
    linkText: `${this.$t('INVOICES_RECEIPTS.HINT.PLAN_AND_CONTRACT_CANCELLATION_CENTRAL_HELP_TEXT')}`,
  }

  async mounted() {
    (this.$refs.contractsProvider as AsyncProvider).requestData().finally(() => {
      this.loading = false;
    });
  }

  public get url(): string {
    return this.returnurl;
  }

  public get params() {
    return {
      organizationId: this.mxSession_organization.id,
      email: this.mxSession_user.email,
      ...(this.maestroContextType === 'SUITE' ? { isZcc: true } : { isZcc: false }),
    };
  }

  public get pageTitle() {
    return this.maestroContextType === 'SUITE' ? this.$t('INVOICE.SUITE_TITLE') : this.$t('INVOICE.TITLE');
  }

  public get headerItems() {
    const breadcrumItens = [];

    if (this.maestroContextType === 'APP') {
      breadcrumItens.push({
        label: `${this.$t('INVOICES_RECEIPTS.BREADCRUMBS.HOME')}`,
        href: '/welcome',
      });
    }

    breadcrumItens.push(...[
      {
        label: `${this.$t('MENU_LEFT.CUSTOMER_AREA')}`,
      },
      {
        label: `${this.pageTitle}`,
        isActive: true,
      },
    ]);

    return [
      {
        title: `${this.pageTitle}`,
        breadcrumItens,
        buttons: [],
      },
    ];
  }

  @contract.Mutation
  public setContract!: (newContract: ContractStore) => void;

  public handleSetContract(data: ContractStore) {
    this.setContract(data);

    let routeUrl = '/payments/contracts';
    if (this.maestroContextType === 'SUITE') routeUrl = '/plans-and-contracts';

    this.$router.push(`${routeUrl}/${data?.contractID || data?.salesforceContractID}/charging`);
  }

  public afterRequest(data: IContract[]) {
    this.once = true;
    if (data && data.length === 1) {
      const [singleContract] = data;

      this.setContract({ ...singleContract, isSingleContract: true } as ContractStore);

      let routeUrl = '/payments/contracts';
      if (this.maestroContextType === 'SUITE') routeUrl = '/plans-and-contracts';
      this.$router.push(`${routeUrl}/${singleContract.contractID || singleContract.salesforceContractID}/charging`);
    }
  }

  public goToNewCustomerArea() {
    window.open(process.env.VUE_APP_NEW_CUSTOMER_AREA_URL);
  }

  // eslint-disable-next-line
  public orderByStatus(data: IContract[]) {
    if (!this.once) {
      return data.sort((contract1: IContract, contract2: IContract) => {
        if (contract1.status === 'Activated') { return -2; }
        if (contract2.status === 'Activated') { return 2; }
        if (contract1.status < contract2.status) { return -1; }
        if (contract1.status > contract2.status) { return 1; }
        return 0;
      });
    }

    return data;
  }
}

